import { PartnerStatus, ProductInterest, QualificationQuestionsAnswers, UseCase } from 'modules/data/domain';
import { useCallback, useState } from 'react';

export const useSetupProfileWizardQualificationQuestionsAnswers = () => {
    const [useCases, setUseCases] = useState<UseCase[]>([]);
    const [answerAboutGL, setAnswerAboutGL] = useState<ProductInterest | PartnerStatus>(ProductInterest.Other);

    const handleSetQualificationQuestionsAnswers = useCallback((answers?: QualificationQuestionsAnswers | null) => {
        setUseCases(answers?.useCase ?? []);

        if (answers) {
            if ('productInterest' in answers && answers.productInterest) {
                if (answers.productInterest?.length > 0) {
                    setAnswerAboutGL(answers.productInterest[0]);
                }
            } else if ('partnerStatus' in answers && answers.partnerStatus) {
                if (answers.partnerStatus?.length > 0) {
                    setAnswerAboutGL(answers.partnerStatus[0]);
                }
            }
        }
    }, []);

    return {
        answerAboutGL,
        useCases,
        handleSetQualificationQuestionsAnswers,
    };
};
